// extracted by mini-css-extract-plugin
export default {"container":"DeclinedReason_container__03P3E","wrapper":"DeclinedReason_wrapper__Ta-HJ"};